export enum InsertTextSnippetsDialogActions {
    INSERT = 'insert',
    CANCEL = 'cancel',
}
